
export {}; 
declare global {
  interface Number {
        roundNbDec(this: number,nbDec:number): number;
  }
}

Number.prototype.roundNbDec = function (this: number,nbDec:number): number {
    if (!nbDec||nbDec<0) return this;
    const mult : number = Math.pow(10,Math.round(nbDec));
    return Math.round(this* mult)/mult;
};

